module.exports = __webpack_public_path__ + "static/media/main_card03_n.b6c450fc.png";